var _path, _tspan, _tspan2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIrving(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 204 189",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#007dbe"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91 189H81l-5-3-5-4 1-1 2-2v-22H56l-1-19-4-1-1 3v3H0v-31h16v9l1 5h3l27 1h2v9h1a82 82 0 0 1 5-1l1-27a67 67 0 0 0-8-1l-1-11V85l4-7 4-7V55H31V20h14v-7l4-5 4-6 25-1 26-1h78v52h-1a5456 5456 0 0 0-42 1h-2v36h53l6 1v21h8v12h-39v7l-3 7-3 6-4 4-4 3-4 2-3 1h-7v33h-1l-34-2-1 3v2H91z"
  })), /*#__PURE__*/React.createElement("text", {
    x: 105,
    y: 111,
    fontFamily: "Arial",
    fontSize: 24,
    fontWeight: 300,
    style: {
      InkscapeFontSpecification: "'Arial Bold'",
      textAlign: "center"
    },
    textAnchor: "middle"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 105,
    y: 111,
    fill: "#ffffff"
  }, "Irving")), _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 105,
    y: 141,
    fill: "#ffffff"
  }, "Building")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIrving);
export default __webpack_public_path__ + "static/media/Irving.447fef6e0c71580dd78d09039e16f8ca.svg";
export { ForwardRef as ReactComponent };